import React, { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { SandboxPage } from '../../pages/Sandbox.page';
import { StacksPage } from '../../pages/Stacks.page';
import { PullRequestPage } from '../../pages/PullRequests.page';

export const PrivateRoutes: FC = () => {
  return <Routes>
    <Route path="/" element={<SandboxPage/>}/>
    <Route path="/stacks" element={<StacksPage/>}/>
    <Route path="/pull-requests" element={<PullRequestPage/>}/>

    <Route path="*" element={<Navigate to="/" replace={true}/>}/>
  </Routes>
};
